export default function StatCard({ label, value, hint, tone = "neutral", icon: Icon, testId }) {
  const tones = {
    neutral: "text-slate-900",
    danger: "text-red-700",
    warning: "text-amber-700",
    success: "text-emerald-700",
    info: "text-[#0D7377]",
  };
  return (
    <div
      data-testid={testId}
      className="bg-white rounded-lg border border-slate-200 shadow-sm p-5 cc-glow hover:shadow-md transition-shadow"
    >
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs font-semibold tracking-wider uppercase text-slate-500">{label}</p>
        {Icon && <Icon className="h-4 w-4 text-slate-400" />}
      </div>
      <p className={`mt-2 font-heading text-3xl font-bold ${tones[tone] || tones.neutral}`}>{value}</p>
      {hint && <p className="mt-1 text-xs text-slate-500">{hint}</p>}
    </div>
  );
}
